export default __webpack_public_path__ + "static/media/cook-time-clock.02bfab5d.svg";